import Handlebars from "handlebars";
import moment from "moment";

Handlebars.registerHelper("momentFormat", function (passedDateString, format) {
  var formatted = moment(passedDateString).format(format);
  return new Handlebars.SafeString(formatted);
});
